<template>
  <div style="height: 800px; width: 100%">
    <l-map
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 80%"
    >
      <l-tile-layer
          :url="url"
          :attribution="attribution"
      />
      <div v-for="monastery in monasteries" :key="monastery.monastery.id" >
        <l-marker v-if="monastery.monastery.latLong[0] != null" :lat-lng="monastery.monastery.latLong">
          <l-popup>
            <div class="is-popup is-equal-margin">
              <p class="is-equal-margin">{{monastery.monastery.name}}</p>
              <a class="button is-submit " @click="chooseMonastery(monastery.monastery.id)">
                ver ficha
              </a>
            </div>
          </l-popup>
        </l-marker>
      </div>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'MonasteriesMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props:{
    monasteries:{type: Array}
  },
  data: ()=>({
    center1: [39.6856045, -8.144873],
    zoom: 7,
    center: [39.6856045, -8.144873],
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
    attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    mapOptions: {
      zoomSnap: 0.5
    },
  }),
  methods:{
    chooseMonastery(id) {
        this.$emit('id', id)
    }
  },
};

</script>

<style scoped>
.is-submit{
  background-color: #e8e5e0;
}

.leaflet-container a {
  color: #333333;
}

.is-equal-margin{
  text-align: center;
}
</style>